export default __webpack_public_path__ + "static/media/tr_TR.1fddb812.svg";